module.exports = __webpack_public_path__ + "static/media/eye.a22d8c86.svg";